module.exports = __webpack_public_path__ + "static/media/howtopaypay.ca8f6064.png";